/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ItauAtualizacaoRecorrencia {
  data?: string;
  status?: ItauAtualizacaoRecorrencia.StatusEnum;
}
export namespace ItauAtualizacaoRecorrencia {
  export type StatusEnum =
    | 'CRIADA'
    | 'APROVADA'
    | 'REJEITADA'
    | 'EXPIRADA'
    | 'CANCELADA';
  export const StatusEnum = {
    CRIADA: 'CRIADA' as StatusEnum,
    APROVADA: 'APROVADA' as StatusEnum,
    REJEITADA: 'REJEITADA' as StatusEnum,
    EXPIRADA: 'EXPIRADA' as StatusEnum,
    CANCELADA: 'CANCELADA' as StatusEnum
  };
}
